// SelfUnlock constants
export const CASA_ACCOUNT_CODE = '0';
export const CREDIT_CARD_CODE = '1';

export const USER_STATUS_NORMAL = '0';
export const USER_STATUS_LOCKED = '1';
export const USER_STATUS_DISABLED = '3';
export const USER_STATUS_ENABLED = '4';
export const USER_STATUS_TAC_LOCK = '8';

export const ACTION_FORGOT_USER_ID = 0;
export const ACTION_RESET_PASSWORD = 1;

export const TAC_INVALID = '31';
export const TAC_EXCEED_MAX_TRIES = '32';
export const TAC_EXPIRED = '33';
export const TAC_NOT_GENERATE = '34';
export const TAC_EXCEED_MAX_USE = '35';
export const DEFAULT_ACTION_VALUE = 0;
export const PASSWORD_REUSED = '12';
export const USERNAME_PASSWORD_CANNOT_SAME = '13';
